import { createQuery } from '../../libs';
import { settingsModel } from './models';
import { long_term_cashing } from '@/constants/cashing';

const url = 'settings';

export const useGetSettings = createQuery<settingsModel>(
  {
    method: 'get',
    url,
  },
  {
    staleTime: long_term_cashing,
  }
);
